export type DateFormatModel = 'DAY_MONTH_YEAR' | 'MONTH_DAY_YEAR' | 'YEAR_MONTH_DAY';
export type DateSeparatorModel = 'DASH' | 'DOT' | 'SLASH' | 'SPACE';

export interface DateTimeFormatConfigModel {
  dateOrder: DateFormatModel;
  separator: DateSeparatorModel;
  use24HrTime: boolean;
}

export enum DateTimeFormats {
  SHORT_DAY_MONTH,
  LONG_DAY_MONTH,
  WEEKDAY_LONG,
  WEEKDAY_LONG_DAY_MONTH,
  SHORT_MONTH_YEAR,
  LONG_MONTH_YEAR,
  SHORT_MONTH,
  LONG_MONTH,
  YEAR,
  QUARTER_YEAR,
  TIME,
  LONG_MONTH_NAME_DAY_COMMA_YEAR,
  FULL_MONTH_NAME_DAY_COMMA_YEAR,
  FULL_MONTH_NAME_YEAR
}

// Named types for readability.
export type TreatAsUTC = boolean; // i.e. consider time zone instead of treating as local date time.
type LongDateFormat = boolean; // e.g. 15 Sept 2022
type DisplayTime = boolean;
type HideTheTimeZoneOffset = boolean;
type ShowSecondsWithTime = boolean;

export type DateTypes = Date | string | number | 'now' | null;

export type DateTimeFormatterFn = (date?: DateTypes, options?: DateTimeFormatterOptions) => string;

export type DateTimeFormat = {
  short: string;
  long: string;
  shortDayMonth: string;
  longDayMonth: string;
  weekdayLong: string;
  weekdayLongDayMonth: string;
  shortMonthYear: string;
  longMonthYear: string;
  shortMonth: string;
  longMonth: string;
  time: string;
  timeWithSeconds: string;
  quarterYear: string;
  year: string;
  longMonthNameDayCommaYear: string;
  fullMonthNameDayCommaYear: string;
  fullMonthNameYear: string;
  threeLetterDateFormat: ThreeLetterDateFormats;
};

export type ThreeLetterDateFormats = 'dmy' | 'mdy' | 'ymd';

export type DateTimeFormatterOptions = {
  format?: DateTimeFormats;
  long?: LongDateFormat;
  utc?: TreatAsUTC;
  time?: DisplayTime;
  noTimeZone?: HideTheTimeZoneOffset;
  seconds?: ShowSecondsWithTime;
};

export const SEPARATOR_DICTIONARY = {
  DASH: '-',
  DOT: '.',
  SLASH: '/',
  SPACE: ' '
} as const;

export const DEFAULT_DATE_TIME_FORMAT: DateTimeFormatConfigModel = {
  dateOrder: 'MONTH_DAY_YEAR',
  separator: 'SLASH',
  use24HrTime: true
};
